import React from "react";
import { Panel as BSPanel } from "react-bootstrap";
import { RenderProp, handleRenderProp } from "../../utils/handleRenderProp";
import "./Panel.scss";

export type PanelProps = {
    title: RenderProp | JSX.Element | string;
    buttons?: RenderProp | JSX.Element;
    footer?: RenderProp | JSX.Element;
    expanded?: boolean;
    collapsible?: boolean;
    style?: string;
    className?: string;
    centerButtonBar?: RenderProp | JSX.Element;
    innerRef?: any;
};

type State = {
    expanded: boolean;
};

export class Panel extends React.Component<PanelProps, State> {
    state: State = {
        expanded: (this.props.expanded === undefined || this.props.expanded === true) ? true : false
    };

    render() {
        const { title, buttons, footer, centerButtonBar, collapsible = true } = this.props;

        let titleContent = handleRenderProp(title);
        let buttonContent = handleRenderProp(buttons);
        let footerContent = handleRenderProp(footer);
        let centerContent = handleRenderProp(centerButtonBar)

        //if we have buttonContent, create a panel with a buttons bar
        let panelTitle = (
            <BSPanel.Title toggle={collapsible} componentClass='h4'>
                {titleContent}
            </BSPanel.Title>
        );
        let headerContent: JSX.Element;
        if (buttonContent || centerButtonBar) {
            headerContent = (
                <>
                    {panelTitle}
                    {centerContent && <div className='center-bar'>{centerContent}</div>}
                    {buttonContent && <div className='button-bar'>{buttonContent}</div>}
                </>
            );
        } else {
            headerContent = panelTitle;
        }

        return (
            <BSPanel
                ref={this.props.innerRef}
                defaultExpanded={this.state.expanded}
                bsStyle={this.props.style || "default"}
                className={`cs-react ${this.props.className || ""}`}
            >
                <BSPanel.Heading >{headerContent}</BSPanel.Heading>
                <BSPanel.Body collapsible={collapsible}>
                    {this.props.children}
                </BSPanel.Body>
                {this.props.footer && <BSPanel.Footer>{footerContent}</BSPanel.Footer>}
            </BSPanel>
        );
    }
}

(Panel as any).displayName = "Panel";
